fx.ns("filters.photofilters", class BlackWhiteFilter extends filters.photofilters.BaseFilter {
    
    constructor(parameters)
    {
        super(parameters);
    };

   filterFCN(add)
	{
    	add.colorMatrix('matrix', [ 0.33, 0.33, 0.33, 0, 0, 0.33, 0.33, 0.33, 0, 0, 0.33, 0.33, 0.33, 0, 0, 0, 0, 0, 1, 0 ]);
	}
      


});
        